<template>
  <div class="user-form">
    <toolbar
      backRoute="/dashboard/my-profile"
      title="Activate 2FA" />

    <d-container fluid class="common-form px-0 pt-5 pb-5 text-center">
      <d-form>
        <validation-observer ref="activate-2fa-form" tag="form" v-if="!loadError && allDataLoaded">
          <d-row>
            <d-col cols="4" class="ml-auto mr-auto">
              <div class="form-group">
                <p>Scan below image in your 2FA application and provide a generated 6-digit code to activate 2FA for your account.</p>
                <img
                  :src="data.qr_code"
                  alt=""
                  height="200"
                  width="200" />
              </div>

              <div class="form-group">
                <label for="name">Code:</label>

                <validation-provider
                  rules="required"
                  name="code"
                  v-slot="{ errors }">
                  <d-input
                    v-model="data.code"
                    type="number"
                    :length="6"
                    size="lg"
                    class="w-50 ml-auto mr-auto"
                    :state="errors.length ? 'invalid' : null" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group d-flex mt-5 text-center">
                <d-button
                  outline
                  theme="success"
                  class="ml-auto mr-auto"
                  @click.prevent="validateForm">
                  Activate 2FA
                </d-button>
              </div>
            </d-col>
          </d-row>
        </validation-observer>

        <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
          Loading data&hellip;
        </div>

        <d-alert
          v-if="loadError"
          show
          theme="warning">
          The app were unable to load data. <a href="javascript:window.location.reload();" class="alert-link">Refresh the app</a> to try again.
        </d-alert>
      </d-form>
    </d-container>
  </div>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';

export default {
  name: 'activate-2fa-form',
  computed: {
    allDataLoaded () {
      return this.loadedData;
    }
  },
  data () {
    return {
      data: {
        qr_code: '',
        code: ''
      },
      loadError: false,
      loadedData: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/2fa/prepare',
        id: null,
        instanceFields: ['qr_code'],
        loadedKey: 'loadedData'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['activate-2fa-form'], this.submitForm);
    },
    submitForm () {
      let endpointUrl = '/2fa/enable';

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: {
          code: this.data.code
        },
        successTitle: '2FA has been activated',
        successText: 'Your account is now protected with 2FA',
        errorTitle: 'An error occurred!',
        errorText: 'The operation not finished successfully. Please try again.',
        successAction: () => {
          this.$router.push('/dashboard/my-profile');
          this.$root.loadProfile();
        },
        failAction: () => {
          this.data.code = '';
        }
      });
    }
  }
}
</script>
